import {ENDPOINT_AUTH} from 'common/endpoints';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import {commonJwtHeader} from 'common/utils';

const authLogin = (username, password) => {
  return fetch(`${ENDPOINT_AUTH}`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify({username, password}),
  });
};

export default {
  authLogin,
};
